import { API } from 'lib/apis/constants';
import { urlConfig } from 'lib/config';
import HttpRequest, { IHttpRequest } from './request';

class SessionRequest {
  private httpRequest: HttpRequest;
  constructor({ baseUrl }: IHttpRequest) {
    this.httpRequest = new HttpRequest({
      baseUrl,
    });
  }

  public checkSession(token: string) {
    return this.httpRequest.request({
      url: API.CHECK_SESSION,
      method: 'POST',
      data: {
        token,
      },
    });
  }

  public fetchAMSRequest({ url, params, data, headers, baseURL }) {
    return this.httpRequest.request({
      baseURL,
      url,
      method: 'POST',
      headers,
      params,
      data,
    });
  }
}

const sessionRequest = new SessionRequest({
  baseUrl: urlConfig.loginUrl,
});
export default sessionRequest;
